<div class="search-container">
  <!--<h1 class="search-title">{{ 'SEARCH.ADVANCED_TITLE' | translate }}</h1>-->
  
  <!-- Loader durante la ricerca -->
  <div *ngIf="isLoading" class="search-loading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p>{{ 'SEARCH.LOADING' | translate }}</p>
  </div>
  
  <!-- Risultati della ricerca -->
  <div *ngIf="!isLoading && searchResults.length > 0" class="search-results">
    <h2>{{ 'SEARCH.RESULTS_TITLE' | translate }} ({{ searchResults.length }})</h2>
    
    <!-- Tabella dei risultati -->
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>{{ getColumnTitle(searchParams.category, 'code') }}</th>
            <th>{{ getColumnTitle(searchParams.category, 'description') }}</th>
            <th>{{ getColumnTitle(searchParams.category, 'date') }}</th>
            <th>{{ getColumnTitle(searchParams.category, 'status') }}</th>
            <th>{{ 'SEARCH.ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let result of searchResults" (click)="viewDetail(result)">
            <td><strong>{{ result.code }}</strong></td>
            <td>{{ result.description }}</td>
            <td>{{ result.date | date:'dd/MM/yyyy' }}</td>
            <td>
              <span class="status-badge" [ngClass]="'status-' + result.status">
                {{ getStatusLabel(result.status) }}
              </span>
            </td>
            <td>
              <button class="btn btn-sm btn-outline-primary" (click)="viewDetail(result); $event.stopPropagation()">
                <i class="fas fa-eye"></i>
              </button>
              <button class="btn btn-sm btn-outline-secondary" (click)="downloadPdf(result); $event.stopPropagation()">
                <i class="fas fa-download"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <!-- Paginazione -->
    <div class="pagination-controls">
      <button class="btn btn-sm" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
        <i class="fas fa-chevron-left"></i>
      </button>
      <span>{{ 'SEARCH.PAGE' | translate }} {{ currentPage }} / {{ totalPages }}</span>
      <button class="btn btn-sm" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>
  
  <!-- Messaggio nessun risultato -->
  <div *ngIf="!isLoading && searchPerformed && searchResults.length === 0" class="no-results">
    <i class="fas fa-search fa-3x"></i>
    <h3>{{ 'SEARCH.NO_RESULTS' | translate }}</h3>
    <p>{{ 'SEARCH.TRY_AGAIN' | translate }}</p>
  </div>
</div>
